/**
 * Centralized registry for all Global Symbols used across the Magma monorepo.
 * These symbols utilize Symbol.for() to ensure consistency across module boundaries.
 */
export const $Target = Symbol.for('$LibraryTarget');
export const $Discover = Symbol.for('$LibraryDiscover');
export const $Extensible = Symbol.for('$LibraryExtensible');
export const $Inspect = Symbol.for('nodejs.util.inspect.custom');
export const $LogConfig = Symbol.for('$LibraryLogConfig');
export const $Registry = Symbol.for('$LibraryRegistry');
export const $Register = Symbol.for('$LibraryRegister');
export const $SerializerRegistry = Symbol.for('$LibrarySerializerRegistry');
export const $ImmutableSkip = Symbol.for('$LibraryImmutableSkip');
export const $Identity = Symbol.for('$LibraryIdentity');
export const sym = {
    $Target, $Discover, $Extensible, $Inspect, $LogConfig, $Registry, $Register, $SerializerRegistry, $Identity, $ImmutableSkip
};
/**
 * Identifies and marks an object as a logging configuration object using a global symbol.
 * This allows the library to securely differentiate configs from regular objects.
 *
 * @param obj - The configuration object to mark
 * @returns The marked object
 * @example
 * ```ts
 * const cfg = markConfig({ level: 'debug' });
 * ```
 */
export function markConfig(obj) {
    if (!obj[sym.$LogConfig] && Object.isExtensible(obj))
        Object.defineProperty(obj, sym.$LogConfig, { value: true, enumerable: false, writable: true, configurable: true });
    return obj;
}
